import { scrollToId } from "../lib/motion";

const scrollTo = scrollToId;

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-nexis-bg py-14" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
          <button onClick={() => scrollTo("hero")} className="flex items-center gap-2.5">
            <span className="relative flex h-7 w-7 items-center justify-center">
              <span className="absolute inset-0 rounded-md bg-gradient-to-br from-nexis-blue to-nexis-purple" />
              <span className="relative font-display text-sm font-bold text-black">N</span>
            </span>
            <span className="font-display text-lg font-semibold tracking-tight">
              Nexis<span className="text-nexis-blue">.</span>team
            </span>
          </button>

          <div className="flex flex-wrap gap-x-8 gap-y-2 text-sm text-white/50">
            <button onClick={() => scrollTo("services")} className="hover:text-white" data-testid="footer-services">Capabilities</button>
            <button onClick={() => scrollTo("data-center")} className="hover:text-white" data-testid="footer-infra">Infrastructure</button>
            <button onClick={() => scrollTo("ai")} className="hover:text-white" data-testid="footer-ai">Intelligence</button>
            <button onClick={() => scrollTo("contact")} className="hover:text-white" data-testid="footer-contact">Contact</button>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-white/5 pt-8 text-xs text-white/35 md:flex-row md:items-center">
          <span>© {new Date().getFullYear()} Nexis.team — Enterprise Transformation, AI & Critical Infrastructure.</span>
          <span className="font-mono tracking-wider">BUILDING TOMORROW'S ENTERPRISE</span>
        </div>
      </div>
    </footer>
  );
}
